import type { ModificationGroupLimits, ModificationsMap } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns the extras addition cost for an ingredient if its included group
 * is at capacity. Returns undefined when the ingredient has no paired extra
 * or the included group still has room.
 */
export function getUpsellPrice(params: Params): number | undefined {
  const {
    ingredientId,
    allModificationsMap,
    extrasModificationsMap,
    modificationLimits,
    includedGroupCounts,
  } = params;

  if (!ingredientId || !allModificationsMap) return undefined;

  const modification = allModificationsMap.get(ingredientId);

  if (!modification?.ingredientId) return undefined;

  const extrasModification = extrasModificationsMap.get(modification.ingredientId);

  if (!extrasModification) return undefined;

  const groupLimits = modificationLimits[modification.modificationGroupName];

  if (!groupLimits) return undefined;

  const activeCount = includedGroupCounts[modification.modificationGroupName] ?? 0;

  if (activeCount < groupLimits.maxAggregateQuantity) return undefined;

  return extrasModification.additionCost;
}

// ─── Types ──────────────────────────────────────────────────────────────────

type Params = {
  ingredientId: string | undefined;
  allModificationsMap: ModificationsMap | undefined;
  extrasModificationsMap: ModificationsMap;
  modificationLimits: ModificationGroupLimits;
  includedGroupCounts: Record<string, number>;
};
